import {CALL_API} from 'middleware/api';

import * as Actions from '../PhoneConfirmation';

function fetchPhoneConfirmation(data) {
    const {gamblerId, newPhone, oldPhone} = data;
    return {
        type: Actions.CREATE_PHONE_CONFIRMATION,
        [CALL_API]: {
            endpoint: `/api/gambler/${gamblerId}/phone/create?newPhone=${newPhone}&oldPhone=${oldPhone}`,
            method: 'post',
            types: [
                Actions.SUCCESS_CREATE_PHONE_CONFIRMATION,
                Actions.FAILURE_CREATE_PHONE_CONFIRMATION
            ],
            credentials: true,
            data
        }
    };
}

export function createPhoneConfirmation(data) {
    return (dispatch) => {
        dispatch(fetchPhoneConfirmation(data));
    };
}

function fetchConfirmPhone(data) {
    const {gamblerId, code, authorize} = data;
    return {
        type: Actions.CONFIRM_PHONE,
        [CALL_API]: {
            endpoint: `/api/gambler/${gamblerId}/phone/confirm?code=${code}&authorize=${authorize}`,
            method: 'post',
            types: [
                Actions.SUCCESS_CONFIRM_PHONE,
                Actions.FAILURE_CONFIRM_PHONE
            ],
            credentials: true,
            data
        }
    };
}

export function confirmPhone(data) {
    return (dispatch) => {
        dispatch(fetchConfirmPhone(data));
    };
}

export function denyConfirmation() {
    return {type: Actions.DENY_CONFIRMATION};
}



// WEBPACK FOOTER //
// ./js/actions/creators/PhoneConfirmation.js